import { Flex } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import Text from 'components/base/Text';
import { Switch } from '@material-ui/core';
import { learnMoreWorkerBInlineApproval } from 'common/constants/articles';
import { LBArrowCornerRightUpIcon, LBButton } from '@linearb/buzz';

const ActionableNotifications = ({ isEnabled, onSwitchChange }) => (
  <Flex
    direction='column'
    mb='medium'
    pt='big'
    borderBottom={`1px solid ${getColor('botticelli')}`}
  >
    <Text size='large' textTransform='uppercase'>
      Actionable notifications
    </Text>
    <Flex direction='column' pt='smaller' pb='medium'>
      <Flex items='center'>
        <Switch
          size='small'
          checked={isEnabled}
          onChange={event => onSwitchChange(event.target.checked)}
        />
        <Text size='large' color='shuttleGray' ml='0.5rem'>
          Allow actions on PRs in Slack notifications (like approving pull
          requests)
        </Text>
        <div className='ml-2'>
          <LBButton variant='outline' asChild>
            <a href={learnMoreWorkerBInlineApproval} target='__blank'>
              Learn more
              <LBArrowCornerRightUpIcon />
            </a>
          </LBButton>
        </div>
      </Flex>
    </Flex>
  </Flex>
);

export default ActionableNotifications;
